export const API = `https://api-admin-stage.7seasol.in/`
// export const API = process.env.REACT_APP_API_ENDPOINT
// export const API = process.env.REACT_APP_API_ENDPOINT
// export const API = `http://192.168.1.12:8080/`
